module.exports = __webpack_public_path__ + "static/media/leanplum.22032d8c.svg";